import React from "react";
import { AdminHeader } from "@/components/navigation/AdminHeader";
import { AdminBreadcrumb } from "./AdminBreadcrumb";
import { cn } from "@/lib/utils";

interface AdminPageLayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
  className?: string;
  actions?: React.ReactNode;
  showBreadcrumb?: boolean;
}

export function AdminPageLayout({ 
  children, 
  title,
  description,
  className,
  actions,
  showBreadcrumb = true
}: AdminPageLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <AdminHeader />
      <main className={cn("container mx-auto px-4 pt-24 pb-6", className)}>
        {showBreadcrumb && <AdminBreadcrumb />}
        
        {(title || actions) && (
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <div>
              {title && <h1 className="text-2xl font-bold">{title}</h1>}
              {description && <p className="text-muted-foreground mt-1">{description}</p>}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
          </div>
        )}
        
        {children}
      </main>
    </div>
  );
}
